import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import DOMPurify from 'dompurify';
import { Location } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class LoginService {

	validation: any = {};
	validationErrors: string = "";

	constructor(
		private router: Router,
		private configService: ConfigService,
		private location: Location,
		private userService: UserService
	) {
		this.createRegexs();
	}

	showLogin(): void {
		this.router.navigate(['/login']);
	}

	getValidationResponse(validPass: boolean): string {
		let message = this.validation?.msg ?? "";
		return `
		    <div class="checklist text-center">
		      <i class="text-${validPass ? 'green' : 'red'} fa fa-${validPass ? 'check' : 'times'} fa-3x" aria-hidden="true"></i>
		      <p class="text-left">${message}</p>
		    </div>
		  `;
	}

	createRegexs(): void {
		this.userService.getPasswordPolicies().then(
			(regex: any) => {
				this.validation.msg = "";
				this.validation.regex = {};
				for (let key in regex) {
					if (regex[key]) {
						this.validation.regex[key] = new RegExp(regex[key]);
					}
					this.validation.msg += key + "<br>";
				}
			},
			(err: any) => {
				console.error("Failed to create policy validation", err);
			}
		);
	}

	passwordValidate(password: string): boolean {
		let valid = true;

		for (let key in this.validation.regex) {
			if (!this.validation.regex[key].test(password)) {
				valid = false;
				this.validationErrors += key + ".\n";
			}
		}

		return valid;
	}

	getValidationErrors(): string {
		return this.validationErrors;
	}
	
	/**
	 * Provides simple input sanitation.
	 */
	sanitizeInput(input: string): string {
		if (!input) return '';
		return DOMPurify.sanitize(input);
	}	
}
